import React from 'react';
import AccountingLedgerFilters, { AccountingLedgerFiltersProps } from '../accounting/AccountingLedgerFilters';

type APFiltersProps = Omit<AccountingLedgerFiltersProps, 'view'>;

const APFilters: React.FC<APFiltersProps> = (props) => (
    <AccountingLedgerFilters {...props} view="ar" />
);

export default APFilters;
